export const HUD = {
  panel: "rounded-2xl border border-cyan-400/10 bg-[#0B1017]/90 backdrop-blur-xl",
  label: "font-['JetBrains_Mono'] text-[10px] uppercase tracking-[0.28em] text-cyan-300/60",
  mono: "font-['JetBrains_Mono']",
  input: "bg-[#070A0F] border-cyan-400/15 text-white placeholder:text-gray-600 focus-visible:ring-cyan-400/40",
  btn: "rounded-full bg-cyan-400 hover:bg-cyan-300 text-black font-semibold",
  ghost: "rounded-full border border-cyan-400/25 text-cyan-200 hover:bg-cyan-400/10",
};

export const ACTION_LABELS = {
  mark_paid: "Record payment",
  start_service: "Start service",
  stop_service: "Finish service",
  cancel_booking: "Cancel booking",
  set_closed_day: "Close day",
  set_working_hours: "Set hours",
  add_knowledge: "Save to knowledge",
  confirm_booking: "Confirm booking",
  reschedule_booking: "Reschedule booking",
  counter_offer: "Send counter-offer",
  add_appointment: "Add appointment",
  send_sms: "Send text message",
  place_call: "Place AI call",
  categorize_transaction: "File bank transaction",
};

export const fmtMoney = (n) =>
  `${Number(n) < 0 ? "-" : ""}$${Math.abs(Number(n || 0)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString();
};

export const downloadFile = async (path, params, filename) => {
  const { default: api } = await import("@/lib/api");
  const r = await api.get(path, { params, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};
